import React, { FC } from 'react';

type Props = {
  classCss?: string;
  props?: React.SVGProps<SVGSVGElement>;
};
const IconArrowFirst: FC<Props> = ({ classCss, props }) => {
  return (
    <svg viewBox="0 0 24 24" version="1.1">
      <g
        id="frist"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        className={classCss}
        {...props}
      >
        <path
          d="M6.45181979,0 L6.491,11.491 L17.5817454,0 L18.6257226,1.08170164 L8.86946003,11.1920403 L8.05041504,12 L8.7872222,12.7227502 L18.6257226,22.9172779 L17.5817454,24 L6.494,12.511 L6.53405762,24 L5,24 L5,0 L6.45181979,0 Z"
          id="Combined-Shape"
          fill="#393D49"
        />
      </g>
    </svg>
  );
};

export default IconArrowFirst;
